import type { IconProps } from './types';

export type ClosedCaptionIconProps = {
  isActive?: boolean;
} & IconProps;

export const ClosedCaptionIcon = (props: ClosedCaptionIconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
    isActive = false,
  } = props;

  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      className={className}
    >
      {isActive ? (
        // Filled version (on state)
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.41667 3.335H19.5833C20.775 3.335 21.75 4.31 21.75 5.50167V18.5017C21.75 19.6933 20.775 20.6683 19.5833 20.6683H4.41667C3.21417 20.6683 2.25 19.6933 2.25 18.5017V5.50167C2.25 4.31 3.21417 3.335 4.41667 3.335ZM9.83333 15.2517H6.58333C5.9875 15.2517 5.5 14.7642 5.5 14.1683V9.835C5.5 9.23917 5.9875 8.75167 6.58333 8.75167H9.83333C10.4292 8.75167 10.9167 9.23917 10.9167 9.835V11.135H9.29167V10.3767H7.125V13.6267H9.29167V12.8683H10.9167V14.1683C10.9167 14.7642 10.4292 15.2517 9.83333 15.2517ZM17.4167 15.2517H14.1667C13.5708 15.2517 13.0833 14.7642 13.0833 14.1683V9.835C13.0833 9.23917 13.5708 8.75167 14.1667 8.75167H17.4167C18.0125 8.75167 18.5 9.23917 18.5 9.835V11.135H16.875V10.3767H14.7083V13.6267H16.875V12.8683H18.5V14.1683C18.5 14.7642 18.0125 15.2517 17.4167 15.2517Z"
          fill={color}
        />
      ) : (
        // Outline version (off state)
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 5.5H5C4.72331 5.5 4.5 5.72354 4.5 6V18C4.5 18.2765 4.72331 18.5 5 18.5H19C19.2716 18.5 19.5 18.2716 19.5 18V6C19.5 5.72843 19.2716 5.5 19 5.5ZM5 4H19C20.1 4 21 4.9 21 6V18C21 19.1 20.1 20 19 20H5C3.89 20 3 19.1 3 18V6C3 4.9 3.89 4 5 4Z"
            fill={color}
          />
          <path
            d="M7 15H10C10.55 15 11 14.55 11 14V12.8H9.5V13.5H7.5V10.5H9.5V11.2H11V10C11 9.45 10.55 9 10 9H7C6.45 9 6 9.45 6 10V14C6 14.55 6.45 15 7 15ZM14 15H17C17.55 15 18 14.55 18 14V12.8H16.5V13.5H14.5V10.5H16.5V11.2H18V10C18 9.45 17.55 9 17 9H14C13.45 9 13 9.45 13 10V14C13 14.55 13.45 15 14 15Z"
            fill={color}
          />
        </>
      )}
    </svg>
  );
};
